import React from 'react'
import { Button, makeStyles, tokens } from '@fluentui/react-components'
import { DismissRegular } from '@fluentui/react-icons'
import { Text } from '../../components/common/texts/Text'
import { t } from '../../i18n/i18n'

const useStyles = makeStyles({
   // No min height, so the row collapses to nothing when idle.
   root: {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacingHorizontalM,
   },
   count: {
      fontWeight: tokens.fontWeightSemibold,
   },
   explanation: {
      color: tokens.colorNeutralForeground3,
   },
})

type DemandSearchSummaryProps = {
   isSearching: boolean
   /** Withholds the counts, so "0 hits" is never announced mid-load. */
   loading: boolean
   demandCount: number
   questionCount: number
   onClear: () => void
}

export const DemandSearchSummary = ({ isSearching, loading, demandCount, questionCount, onClear }: DemandSearchSummaryProps): JSX.Element => {
   const classes = useStyles()

   const demandLabel = demandCount === 1 ? t('SearchHitsDemand') : t('SearchHitsDemands')
   const questionLabel = questionCount === 1 ? t('SearchHitsQuestion') : t('SearchHitsQuestions')

   return (
      <div className={classes.root}>
         {/* Mounted even when idle: a live region appearing with its first content is not announced. */}
         <span role="status" aria-live="polite" aria-atomic="true" className={classes.count}>
            {isSearching && !loading ? `${demandCount} ${demandLabel} · ${questionCount} ${questionLabel}` : ''}
         </span>
         {isSearching && (
            <>
               <Text as="caption" className={classes.explanation}>
                  {t('SearchingAllTabs')}
               </Text>
               <Button appearance="subtle" size="small" icon={<DismissRegular />} onClick={onClear}>
                  {t('ClearSearch')}
               </Button>
            </>
         )}
      </div>
   )
}
